import { Link } from "react-router-dom";
import { Logo } from "./Logo";

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Cookie Notice", to: "/cookies" },
];

export const Footer = () => (
  <footer className="relative border-t border-white/[0.06] py-8 md:py-10" data-testid="site-footer">
    <div className="mx-auto max-w-[1240px] px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
      <Logo className="h-11 w-auto" />

      <div className="flex flex-col md:items-end gap-3">
        <nav className="flex flex-wrap items-center gap-x-3 gap-y-2 text-sm" data-testid="footer-legal-links">
          {legalLinks.map((l, i) => (
            <span key={l.to} className="flex items-center gap-x-3">
              <Link
                to={l.to}
                data-testid={`footer-link-${l.to.slice(1)}`}
                className="text-slate-400 hover:text-teal transition-colors"
              >
                {l.label}
              </Link>
              {i < legalLinks.length - 1 && <span className="text-slate-700">|</span>}
            </span>
          ))}
        </nav>
        <p className="text-sm text-slate-500">© 2026 Cypress Group, LLC</p>
      </div>
    </div>
  </footer>
);
